import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CatalogNewMain } from "@/features/office/catalog-new";
import { CatalogNewGate } from "@/features/shared/feature-gates/catalog-new-gate";
import {
  filterSearchFragment,
  notificationSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  search: z.string().optional(),
  ...filterSearchFragment,
  filters: z
    .object({
      categoryId: withOperators(commaListSchema),
      groupId: withOperators(commaListSchema),
      workType: withOperators(commaListSchema),
      source: withOperators(commaListSchema),
      ...notificationSearchFragment,
    })
    .optional(),
  sort: z.string().optional(),
  ...maskSearchFragment,
});

export const routeId = "/office/catalog-new/";
export const Route = createFileRoute("/office/catalog-new/")({
  validateSearch: searchSchema,
  component: () => (
    <CatalogNewGate>
      <CatalogNewMain />
    </CatalogNewGate>
  ),
});
